<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <!-- style="height: 50vh" -->
    <div class="flex flex-col gap-3 lg:justify-between lg:flex-row">
      <!-- Formulário -->

      <ng-container [ngSwitch]="tabSelecionada">
        <ng-container *ngSwitchCase="ECompanyTabsEdit.DadosEmpresa">
          <app-tab-dados-empresa class="w-full" [formCompany]="formCompany" [partners]="partners">
            <div inputImage
              class="relative rounded border border-gray-500 w-28 h-24 mb-3 cursor-pointer flex items-center justify-center h-full"
              (click)="inputLogoEmpresa.click()">
              <ng-container *ngIf="!companyLogo; else temImagem">
                <span>+ LOGO</span>
              </ng-container>

              <ng-template #temImagem>
                <img class="rounded-sm shadow-sm w-52 max-w-52" [src]="'data:image/png;base64,' + companyLogo"
                  alt="Logo" />
              </ng-template>

              <input type="file" #inputLogoEmpresa style="display: none" accept="image/png"
                (change)="onImageInput($event)" />
            </div>
          </app-tab-dados-empresa>
        </ng-container>
        <ng-container *ngSwitchCase="ECompanyTabsEdit.Filiais">
          <app-tab-filiais class="w-full" style="max-width: 800px" [dadosPaginacaoFiliais]="dadosPaginacaoFiliais"
            [filiais]="filiais" [companyId]="companyId" (mudouPagina)="mudouPaginaFilial($event)"
            (mudouTamanhoPagina)="mudouTamanhoPaginaFilial($event)"
            (recarregarListagem)="carregarFiliais()"></app-tab-filiais>
        </ng-container>
        <ng-container *ngSwitchCase="ECompanyTabsEdit.UsuariosAdmin">
          <app-tab-usuarios-admin class="w-full" [dadosPaginacaoUsuariosAdmin]="dadosPaginacaoUsuariosAdmin"
            [usuariosAdmin]="usuariosAdmin" (mudouPagina)="mudouPaginaUsuariosAdmin($event)" [companyId]="companyId"
            (mudouTamanhoPagina)="mudouTamanhoPaginaUsuariosAdmin($event)"
            (recarregarListagem)="carregarUsuariosAdmin()"></app-tab-usuarios-admin>
        </ng-container>
        <ng-container *ngSwitchCase="ECompanyTabsEdit.CentroCusto">
          <app-tab-centro-custo class="w-full" style="max-width: 800px"
            [dadosPaginacaoCentroDeCusto]="dadosPaginacaoCentroDeCusto" [centros]="centros" [companyId]="companyId"
            (mudouPagina)="mudouPaginaCentroDeCusto($event)"
            (mudouTamanhoPagina)="mudouTamanhoPaginaCentroDeCusto($event)"
            (recarregarListagem)="carregarCentroDeCustos()"></app-tab-centro-custo>
        </ng-container>
        <ng-container *ngSwitchCase="ECompanyTabsEdit.Colaboradores">
          <app-tab-colaboradores class="w-full" style="max-width: 800px"
            [dadosPaginacaoColaborador]="dadosPaginacaoColaborador" [employers]="employers" [companyId]="companyId"
            (mudouPagina)="mudouPaginaColaborador($event)" (mudouTamanhoPagina)="mudouTamanhoPaginaColaborador($event)"
            (recarregarListagem)="carregarColaboradores()"></app-tab-colaboradores>
        </ng-container>
        <ng-container *ngSwitchCase="ECompanyTabsEdit.Medicos">
          <app-tab-medicos class="w-full" style="max-width: 800px" [dadosPaginacaoMedicos]="dadosPaginacaoMedicos"
            [doctors]="doctors" [companyId]="companyId" (mudouPagina)="mudouPaginaMedico($event)"
            (mudouTamanhoPagina)="mudouTamanhoPaginaMedico($event)"
            (recarregarListagem)="carregarMedicos()"></app-tab-medicos>
        </ng-container>
        <ng-container *ngSwitchCase="ECompanyTabsEdit.Motivos">
          <app-tab-add-reason [companyId]="companyId" [partnerId]="formCompany.get('partnerId')?.value" class="w-full" style="max-width: 800px"></app-tab-add-reason>
        </ng-container>
        <ng-container *ngSwitchCase="ECompanyTabsEdit.Atendentes">
          <app-tab-atendentes class="w-full" [dadosPaginacaoAtendentes]="dadosPaginacaoAtendentes"
            [atendentes]="atendentes" (mudouPagina)="mudouPaginaUsuariosAdmin($event)" [companyId]="companyId"
            (mudouTamanhoPagina)="mudouTamanhoPaginaUsuariosAdmin($event)"
            (recarregarListagem)="carregarUsuariosAdmin()"></app-tab-atendentes>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <p>Aba não encontrada.</p>
        </ng-container>
      </ng-container>

      <!-- Menu Lateral -->
      <div
        class="relative flex flex-row justify-between gap-5 p-3 lg:px-10 sm:justify-start sm:gap-3 sm:flex-wrap lg:flex-col lg:justify-end bg-iceberg menu lg:h-auto w-1/3"
        style="min-height: 550px">
        <button class="absolute w-12 h-10 rounded-sm lg:top-5 right-10 btn--secondary" routerLink="/dash/empresas">
          X
        </button>

        <div class="flex gap-y-5 flex-col mt-3">
          <div class="flex flex-col justify-end">
            <button type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== ECompanyTabsEdit.DadosEmpresa }"
              (click)="mudarTabSelecionada(ECompanyTabsEdit.DadosEmpresa)">
              Dados Empresa
            </button>
          </div>
          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'subsidiary.list']" type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== ECompanyTabsEdit.Filiais }"
              (click)="mudarTabSelecionada(ECompanyTabsEdit.Filiais)">
              Filiais
            </button>
          </div>
          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'costcenter.list']" type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== ECompanyTabsEdit.CentroCusto }"
              (click)="mudarTabSelecionada(ECompanyTabsEdit.CentroCusto)">
              Centros de Custo
            </button>
          </div>

          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'employee.list']" type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== ECompanyTabsEdit.Colaboradores }"
              (click)="mudarTabSelecionada(ECompanyTabsEdit.Colaboradores)">
              Colaboradores
            </button>
          </div>
          <!-- TODO: Esta escrito "Atendentes" mas o correto é "Médicos" -->
          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'doctor.list']" type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== ECompanyTabsEdit.Medicos }"
              (click)="mudarTabSelecionada(ECompanyTabsEdit.Medicos)">
              Atendentes
            </button>
          </div>

          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'reason.list']" type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== ECompanyTabsEdit.Motivos }"
              (click)="mudarTabSelecionada(ECompanyTabsEdit.Motivos)">
              Motivos
            </button>
          </div>

          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'adminuser.list']" type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== ECompanyTabsEdit.UsuariosAdmin }"
              (click)="mudarTabSelecionada(ECompanyTabsEdit.UsuariosAdmin)">
              Usuários Admin
            </button>
          </div>
        </div>
        <hr class="my-4" />
        <div class="flex gap-y-5 flex-col">
          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'company.update']" type="button" class="btn btn--secondary"
              (click)="editarEmpresa()">
              Salvar Empresa
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
